import ClientDeviceLogCard from '@/components/client/client-device-log-card';
import {
	$appendClientDetailDeviceLogs,
	$clientDetailDeviceLogTypes,
	$clientDetailDeviceLogs,
	$setClientDetailDeviceLogs,
} from '@/entities/client.entity';
import { SOCKET_EVENTS } from '@/api/socket-events';
import { useClientVirtualFeed } from '@/hooks/use-client-virtual-feed';
import { getMockDeviceLogsForClient, paginateMockItems } from '@/mocks/fixtures';
import { useUnit } from 'effector-react';
import { useMemo } from 'react';

interface ClientDeviceLogListProps {
	clientId: string;
	searchText: string;
	enabled: boolean;
	sdkVersion?: string;
}

export default function ClientDeviceLogList({ clientId, searchText, enabled, sdkVersion }: ClientDeviceLogListProps) {
	const [deviceLogs, setDeviceLogs, appendDeviceLogs, logTypes] = useUnit([
		$clientDetailDeviceLogs,
		$setClientDetailDeviceLogs,
		$appendClientDetailDeviceLogs,
		$clientDetailDeviceLogTypes,
	]);

	const extraQuery = useMemo(
		() => (logTypes.length > 0 ? { logTypes } : {}),
		[logTypes],
	);

	const { listRef, content } = useClientVirtualFeed({
		clientId,
		searchText,
		enabled,
		fetchEvent: SOCKET_EVENTS.getClientDeviceLogs,
		responseEvent: SOCKET_EVENTS.addClientDeviceLogs,
		items: deviceLogs,
		setItems: setDeviceLogs,
		appendItems: appendDeviceLogs,
		getItemId: item => item.id,
		extraQuery,
		emptyLabel: 'На этом устройстве ошибок нет',
		renderItem: deviceLog => <ClientDeviceLogCard deviceLog={deviceLog} sdkVersion={sdkVersion} />,
		devMockFetch: ({ cursor, searchText: q }) => {
			let all = getMockDeviceLogsForClient(clientId);
			if (logTypes.length > 0) {
				all = all.filter(log => logTypes.includes(log.logType as (typeof logTypes)[number]));
			}
			const page = paginateMockItems(
				all,
				{ cursor, searchText: q },
				(item, query) =>
					item.message.toLowerCase().includes(query) ||
					(item.threadName?.toLowerCase().includes(query) ?? false) ||
					(item.stackTrace?.toLowerCase().includes(query) ?? false),
			);
			return { clientId, ...page };
		},
	});

	return (
		<div ref={listRef} data-scroll-container className='h-full overflow-auto pr-1 px-1'>
			{content}
		</div>
	);
}
